var _Path, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgPrescriptionChat = function SvgPrescriptionChat(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#prescriptionChat_svg__a)"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#1A1A1A",
    d: "M11.947 0C5.36 0 0 5.356 0 11.938c0 2.746.948 5.406 2.675 7.529a7.16 7.16 0 0 1-2.4 3.116.555.555 0 0 0 .15.972A8.279 8.279 0 0 0 3.107 24c1.45 0 2.868-.377 4.118-1.093 1.493.644 3.081.97 4.723.97 6.588 0 11.947-5.355 11.947-11.938S18.534 0 11.947 0Zm0 22.767a10.75 10.75 0 0 1-4.528-.99.556.556 0 0 0-.526.034 7.163 7.163 0 0 1-5.119.954 8.246 8.246 0 0 0 2.059-3.225.555.555 0 0 0-.104-.544 10.821 10.821 0 0 1-2.618-7.057c0-5.971 4.861-10.828 10.836-10.828 5.975 0 10.836 4.857 10.836 10.827 0 5.971-4.861 10.829-10.836 10.829Z"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    stroke: props.accentFillLine,
    strokeWidth: 0.265,
    d: "m12.352 6.582-5.77 5.77a3.582 3.582 0 1 0 5.066 5.066l5.77-5.77a3.582 3.582 0 1 0-5.066-5.066Zm-6.295 5.246a4.324 4.324 0 0 0 6.115 6.115l5.77-5.77a4.324 4.324 0 0 0-6.114-6.116l-5.77 5.77Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    stroke: props.accentFillLine,
    strokeWidth: 0.265,
    d: "m9.696 11.173-1.902 1.901a2.214 2.214 0 0 0 3.132 3.132l1.902-1.902a.628.628 0 0 0 0-.887l-2.244-2.244a.627.627 0 0 0-.888 0Zm-2.39 1.412a2.906 2.906 0 1 0 4.11 4.11l1.901-1.902a1.32 1.32 0 0 0 0-1.865l-2.244-2.245a1.32 1.32 0 0 0-1.866 0l-1.902 1.902Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeWidth: 0.265,
    d: "M15.989 7.229a1.82 1.82 0 0 0-2.325.07l-.918.812a.327.327 0 0 1-.46-.025.32.32 0 0 1 .028-.454l.918-.812a2.476 2.476 0 0 1 3.162-.095c.14.11.163.312.052.451a.328.328 0 0 1-.457.053Z",
    clipRule: "evenodd"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "prescriptionChat_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPrescriptionChat;